import { render, staticRenderFns } from "./d5.vue?vue&type=template&id=63cc8176&scoped=true"
import script from "./d5.vue?vue&type=script&lang=js"
export * from "./d5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cc8176",
  null
  
)

export default component.exports